<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="12">
        <StatisticsDep />
      </el-col>
      <el-col :span="12">
        <StatisticsTeamLeader />
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <InputTable />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import InputTable from './input-table'
import StatisticsDep from './statistics-dep'
import StatisticsTeamLeader from './statistics-team-leader'
export default {
  components: { InputTable, StatisticsDep, StatisticsTeamLeader },
  props: {},
  data() {
    return {}
  }
}
</script>
